<template>
  <generic-modal :title="$t('scheduled trip')" ref="generic_modal">
    <div class="form">
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("origin") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.origin" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("destination") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.destination" />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('driver')"
              :is_multiple="false"
              :placeholder="$t('driver')"
              url="/trip/driver/catalog"
              name_field="name"
              value_field="driver_id"
              @selected="set_driver"
              ref="driver_dropdown"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('vehicle')"
              :is_multiple="false"
              :placeholder="$t('vehicle')"
              url="/trip/vehicle/catalog"
              name_field="licence_plate"
              value_field="vehicle_id"
              @selected="set_vehicle"
              ref="vehicle_dropdown"
            />
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("departure date") }}</label>
            <div class="control">
              <input
                class="input"
                type="datetime-local"
                v-model="meta.departure_date"
                :min="moment().format('YYYY-MM-DDTHH:mm')"
              />
            </div>
          </div>
        </div>
        <!-- <div class="column">
          <div class="field">
            <label class="label">{{ $t("return date") }}</label>
            <div class="control">
              <input class="input" type="date" v-model="meta.return_date" />
            </div>
          </div>
        </div> -->
        <!-- <div class="column"></div> -->
      </div>
      <div class="" v-if="meta.trip_assigns">
        <div class="title is-5">
          <span class="icon">
            <i class="fa fa-users"></i>
          </span>
          <span>{{ $t("the crew") }}</span>
        </div>
        <div class="grid">
          <div
            class="cell"
            v-for="(itm, iidx) in meta.trip_assigns"
            :key="iidx"
          >
            <div class="card">
              <div class="card-content pt-0">
                <div class="content">
                  <div class="title is-6">{{ itm.request.name }}</div>
                  <div class="subtitle is-7 mb-0">
                    <span class="icon">
                      <i class="fa fa-phone"></i>
                    </span>
                    <span>{{ itm.request.phone }}</span>
                  </div>
                  <div class="subtitle is-7 mb-0">
                    <span class="icon">
                      <i class="fa fa-envelope"></i>
                    </span>
                    <span>{{ itm.request.email }}</span>
                  </div>
                  <div class="subtitle is-7 mb-0">
                    <span class="icon">
                      <i class="fa fa-users"></i>
                    </span>
                    <span>{{ itm.request.passenger_number }}</span>
                  </div>
                  <div class="subtitle is-7 mb-0">
                    <span class="icon">
                      <i class="fa fa-briefcase"></i>
                    </span>
                    <span>{{ itm.request.luggage_number }}</span>
                  </div>
                  <!-- <pre>{{ itm }}</pre> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="notification is-danger mt-5" v-if="error" v-html="error"></div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button
        class="button is-danger is-rounded"
        @click="remove"
        v-if="meta.uuid"
      >
        <span class="icon">
          <i class="fa fa-trash"></i>
        </span>
        <span>{{ $t("delete") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  del,
  confirm_deletion_dialog,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import moment from "moment";

export default {
  name: "EventModal",
  components: { GenericModal, GenericCalendar, GenericDropdown },
  data() {
    return {
      meta: { settings: {} },
      error: "",
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return (
        !v.meta.destination ||
        !v.meta.departure_date ||
        !v.meta.driver_id ||
        !v.meta.vehicle_id
      );
    },
  },
  methods: {
    moment,
    create_from_trip(trip) {
      let v = this;
      v.set_initial_state();
      v.meta.origin = trip.origin;
      v.meta.destination = trip.destination;
      v.meta.departure_date = moment(trip.date).format("YYYY-MM-DDTHH:mm");
      v.$refs.generic_modal.show_modal();
      // v.meta.departure_date = moment(trip.date).format("YYYY-MM-DDTHH:mm");
    },
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    create_event(args) {
      let v = this;
      v.set_initial_state();
      // v.$refs.start_date_calendar.set_date(args.date);
      v.meta.departure_date = moment(args.date).format("YYYY-MM-DDTHH:mm");
      // let end_date = moment(args.date).add(1, "hour");
      // v.$refs.end_date_calendar.set_date(end_date);

      v.$refs.generic_modal.show_modal();
    },
    edit_event(event_uuid) {
      let v = this;
      v.set_initial_state();

      get("/trip/scheduled", { uuid: event_uuid })
        .then((event) => {
          v.meta = event;

          if (event.driver_id)
            v.$refs.driver_dropdown.set_value(event.driver_id);
          if (event.vehicle_id)
            v.$refs.vehicle_dropdown.set_value(event.vehicle_id);

          //   v.$refs.start_date_calendar.set_date(event.departure_date);
          v.meta.departure_date = moment(event.departure_date).format(
            "YYYY-MM-DDTHH:mm"
          );
          // }
          // if (event.return_date) {
          //   v.$refs.end_date_calendar.set_date(event.return_date);
          //   v.meta.return_date = moment(event.return_date);
          // }

          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      v.meta.departure_date = moment(v.meta.departure_date, "YYYY-MM-DDTHH:mm");
      if (!v.meta.uuid)
        put("/trip/scheduled", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/trip/scheduled", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        origin: "",
        destination: "",
        settings: {},
      };
      v.error = "";
      v.$refs.driver_dropdown.clear();
      v.$refs.vehicle_dropdown.clear();
      // v.uuid = "";
    },
    start_date_changed(date) {
      let v = this;
      v.meta.departure_date = date;
    },
    remove() {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure to delete trip?"), v, () => {
        del("/trip/scheduled", { uuid: v.meta.uuid })
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            error_message(error);
          });
      });
    },
    set_driver(driver) {
      let v = this;
      if (driver) v.meta.driver_id = driver.driver_id;
    },
    set_vehicle(vehicle) {
      let v = this;
      if (vehicle) v.meta.vehicle_id = vehicle.vehicle_id;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
